// Australian Ethical
const sgRate = 12;
const contactNumber = {
  value: null,
  text: ""
};
export default {
  "defaults": {
    revision: "5",
    "editAssumptions": {
      wageInflation: 3.7,
      priceInflation: 2.5,
      retirementAge: 67,
      //TPD
      tpdRepayDebtsLiabilities: false,
      tpdFutureIncomeLevel: 100,
      tpdCeaseAllowanceForFutureIncomeAtAge: 65,
      //Income Protection // SG Guarantee
      incomeProtectionPaymentPeriod: 65,
      incomeProtectionPercentage: 75,
      incomeProtectionSuperGuarantee: sgRate,
      MaximumCoverPerMonth: 30000,
      // life insurance
      lifeInsurancePaymentPeriod: 67,
      lifeInsuranceInvestmentReturn: 2.5,
    },
    "fields": {
      // about
      age: { min: 15, max: 69 },
      dependantsAge: { min: 0, max: 18 },
      // debt
      rentAmount: { min: 1, max: 2000 },
      mortgageAmount: { min: 1, max: 5000000 },
      debts: { min: 1, max: 5000000 },
      // income
      salaryYearly: { min: 35000, max: 2000000 }, // 2,000,000
      salaryMonthly: { min: 3000, max: 166666 },// 2,000,000/12 = 166,666
      salaryWeekly: { min: 650, max: 38461 },// 2,000,000/52 = 38,461
      ipSalaryYearly: { min: 6118, max: 2000000 },
      ipSalaryMonthly: { min: 510, max: 166666 },
      ipSalaryWeekly: { min: 118, max: 38461 },
      savings: { min: 0, max: 5000000 },
      assets: { min: 1, max: 5000000 },
      // expenses
      expensesAmountPerMonth: { min: 0, max: 50000 },
      expenses:  { min: 1, max: 50000 },
      disabilityCost: { min: 0, max: 1000000 },
      funeralExpenses: { min: 0, max: 50000 },
      dependantAmount: { min: 0, max: 50000 },
      // cover costs
      TPDCover: { min: 0, max: 5000000 },
      IPCover: { min: 0, max: 360000 }, //Also capped at 85% of the person’s salary

      // edit assumptions
      inflation: { min: 0, max: 10 },
      investmentReturn: { min: 0, max: 10 },
      retirementAge: { min: 55, max: 75 },
      tpdFutureIncomeLevel: { min: 0, max: 100 },
      incomeProtectionPercentage: { min: 0, max: 75 },
      sgRate: { min: sgRate, max: 15 },
      lifeInsurancePaymentPeriod: { min: 55, max: 75 },
    },
    "stepData": {
      age: null,
      gender: 'female',
      familyType: null,
      memberType: "Personal Account",
      // AES ONLY
      memberTypeHidden: true,
      IPmetricFixed: true,
      IPCoverMaxSalaryPercent: 87,
      IPMaxAge: 64,
      fixedNotRounded: true,
      TPDMaxUnits: 48,
      TPDExceedsDeathCoverMaxAge: 24,
      familyTypeSingleExpenses: true,
      //
      occupation: "",
      homeType: "",
      rentAmount: null,
      mortgageAmount: null,
      salaryYearly: null,
      salaryMonthly: null,
      salaryWeekly: null,
      salaryPeriod: 'Year',
      savings: null,
      expensesAmountPerMonth: null,
      disabilityCost: 0,
      funeralExpenses: 15000,
      mergedMemberInsurance: '(ACSRF with insurance)',
      mergedFromSuperFund: 'ACSRF',
    },
    dependants: [{"Age": null, "Amount": 3000, "Error": false}],
    debts: [{"Name":'', "Amount":null, "Error": false}],
    assets: [{"Name":'', "Amount":null, "Error": false}],
    expenses: [{"Name":'', "Amount":null, "Error": false}],

    occupations: [
      {
        type: "professional",
        name: "Professional",
        html: `
          <small>
            <p>You only work within an office or similar environment and your duties do not involve any manual work or teaching and:</p>
            <ul>
              <li>you earn more than $100,000 p.a. (before tax); and</li>
              <li>you hold tertiary qualifications, or are a registered member of a professional institute or governing body in relation to your job, or work as a member of the executive leadership team with your employer.</li>
            </ul>
            <p>Examples include: Accountant, Lawyer/Solicitor, Medical Doctor</p>
          </small>

        `,
        desc: [ ],
        examples: ``,
      },
      {
        type: "white",
        name: "White collar",
        html: `
         <small>
          <p>You only work in an office or similar environment and your duties include managerial, administrative or clerical activities.</p>
          <p>Your job does not involve any manual work or teaching.</p>

            <p>Examples include: Bank Teller, Administrative Assistant, Book-keeper</p>
          </small>
        `,
        desc: [],
        examples: ``,
      },
      {
        type: "light",
        name: "Light manual",
        html: `
          <small>
            <p>You perform light manual skilled work, a classroom teaching role, or trade qualified working in a non-hazardous industry.</p>
            <p>Examples include:</p>
            <ul>
              <li>Classroom Teacher including PE or Music Teacher</li>
              <li>Registered Childcare Worker</li>
              <li>Qualified tradespeople such as Electricians or Landscaper in a domestic environment</li>
              <li>Trade occupations in an office environment such as Equipment Repair Person</li>
              <li>Occupations involving light manual work such as Café owner, retail sales or travelling sales</li>
              <li>Technical occupations requiring field work greater than 20% involving light manual work such as Insurance Assessor, Building Inspector or Surveyor</li>
              <li>Occupations involving the supervision of manual work such as Building Foreman</li>
            </ul>
          </small>
        `,
        desc: [],
        examples: ``,
      },
      {
        type: "manual",
        name: "Manual",
        html: `
          <small>
            <p>You are tertiary or trade qualified for your job, performing moderate to heavy manual work or operate heavy machinery, not in a high-risk occupation^:</p>
            <p>Examples include: Sheet Metal Worker, Mechanic, Plumber, Commercial Electrician</p>
            <p>^High risk occupations include:</p>
            <ul>
              <li>Working at heights or underground</li>
              <li>Working in any occupation that exposes you to danger, such as Firefighter or Pilot</li>
              <li>Working with firearms, such as Police Officers</li>
              <li>Working in heavy manual occupations that do not require tertiary or trade qualifications such as Labourer, Warehouse Worker, Brick Layer, Factory Worker</li>
              <li>Working as an inter-state Bus or Truck Driver</li>
            </ul>
          </small>
        `,
        desc: [],
        examples: ``,
      },
      {
        type: "heavy",
        name: "Heavy manual",
        html: `
          <small>
            <p>You perform moderate to heavy manual work or operate heavy machinery or you are not trade or tertiary qualified for your current job or you work in a high-risk occupation^:</p>
            <p>Examples include: Prison Guard, Removalist, Carpenter</p>
            <p>^High-risk occupations include:</p>
            <ul>
              <li>Working at heights or underground</li>
              <li>Working in any occupation that exposes you to danger, such as Firefighter or Pilot</li>
              <li>Working with firearms, such as Police Officers</li>
              <li>Working in heavy manual occupations that do not require tertiary or trade qualifications such as Labourer, Warehouse Worker, Brick Layer, Factory Worker</li>
              <li>Working as an inter-state Bus or Truck Driver</li>
            </ul>
          </small>
        `,
        desc: [],
        examples: ``,
      }
    ],

    // age: 30,
    // annualIncome: 60000,
    // gender: 'female',
    coverAmount: 0.75,
    benefitPeriod: 2,
    waitingPeriod: 30,
  },
  "content": {
    "companyName": "Australian Ethical",
    contactNumber,
    "homepageSecondaryCtaType": "text",
    "companyLogo": "ae-logo.svg",
    "coverPageIcons": {
      "death": "australianethical/icon-live-your-life.svg",
      "tpd": "australianethical/icon-insurance.svg",
      "ip": "australianethical/protect.svg"
    },
    "footerCompanyName": "Australian Ethical Superannuation Pty Limited (ABN 43 079 259 733 AFSL 526 055)",
    "costTerm": "insurance fees",
    "occupationClassificationTerm": "occupation category",
    "pages": {
      "home": {
        "intro":
        `
          <h1 tabindex="0">Estimate your insurance needs and cost</h1>

          <p>This insurance calculator can help you estimate</p>
          <ul>
            <li>Death cover</li>
            <li>Total and Permanent Disablement (TPD) cover</li>
            <li>Income Protection Cover</li>
          </ul>
          <p>
            To get the best estimate, ensure the information you enter is as accurate as possible.
          </p>
        `,
        "needsButton":
        `
          <h3>Insurance cover and cost</h3>
          <small>
            Estimate how much cover you need based on your personal circumstances and how much it costs.
          </small>
        `,
      },
      "about": {
        "outOfRangeErrorMessage" : "Please enter an age between 15 and 69.",
        "familyTypeSingle": "Having the right insurance is important to help make sure you are financially supported if you were to stop working from either an illness or injury, or to die. Just like you take out insurance to protect your home and car, it’s important to consider whether to have insurance for your most valuable asset - cover your life and income.",
        "familyTypeCouple": "Insurance can help to ease financial stress on your loved ones by paying money in a lump sum should the unexpected happen to you, or provide temporary payments to assist you to meet your day-to-day living expenses while you’re not earning an income.",
        "dependantAgeRangeErrorMessage": "Insurance cover estimates are limited to dependants between ages 0 and 18.",
        "dependantLimitInfoMessage": "You can add up to 5 dependants.",
        "familyTypeRequiredErrorMessage": "Please select a family type",
        "genderRequiredErrorMessage": "Please select your sex at birth",
        "memberTypeRequiredErrorMessage": "Please choose a member type",
        "tooltipGender": "To ensure you are paying the appropriate fee for any insurance cover you may be provided with, we need to know your biological sex at birth. Your gender identity may differ, and we respect that. Please be assured that all gender identities can be provided with insurance.",
      },
      "debt": {
        "mortgageButton": "I have a mortgage on my main home",
        "rentButton": "I rent",
        "noMortgageNoRentButton": "I don't have a mortgage or pay rent",
        "addedDebtLabel": "Total debt",
        "financialCommitmentsText": "The more precise the information you enter, the  more accurate the insurance estimate will be.",
        "yourDebtText": "List debts you want your Death cover to include such as loans, investment property mortgage or a credit card.",
        "mortgageError": "Please enter an amount between $1 and $5,000,000.",
        "rentError": "Please enter an amount between $1 and $2,000.",
        "debtRangeErrorMessage": "Please enter an amount between $1 and $5,000,000.",
        "debtTotalErrorMessage": "Total debts cannot exceed $5,000,000.",
        "singleRentInfoMessage": "As you don't have a dependant or spouse, rent expenses won't be considered in your Death cover calculation.",
        "homeTypeRequiredErrorMessage": "Please select your home option",
      },
      "income": {
        "addedAssetsLabel": "Total assets",
        "yourAssets": "If your investments or large assets can be sold to reduce debt and meet future expenses, you'll need less insurance cover.",
        "savingsError": "Please enter an amount between $0 and $5,000,000.",
        "salaryErrorYear": "Insurance cover estimates are limited to salaries between $35,000 and $2,000,000 p.a.",
        "salaryErrorMonth": "Insurance cover estimates are limited to salaries between $35,000 and $2,000,000 p.a.",
        "salaryErrorWeek": "Insurance cover estimates are limited to salaries between $35,000 and $2,000,000 p.a.",
        "ipSalaryError": "Insurance fees estimates are limited to salaries between $6,118 and $2,000,000 p.a.",
        "salaryBoxError" :"<div class='info-box'><div class='form-row'><div class='col-1 icon'><i class='icon-info'></i></div><div class='col text'>If your salary is outside this range, this calculator may not be suitable for your personal circumstances.</div></div></div>",
        "deathCoverError": "Please enter your preferred Death Cover amount.",
        "TPDCoverError": "Please enter a TPD Cover amount between $0 and $",
        "IPCoverError": "Please enter an Income Protection Cover amount between $0 and $",
        "deathTPDCoverTooltipText": "You can get Death and TPD cover as fixed or age-based units. With age-based units, your cover level changes according to your age. Fixed cover means your cover level usually remains the same as you get older.",
        "deathCoverTooltipText": "You can get Death cover as fixed or age-based units. With age-based units, your cover level changes according to your age. Fixed cover means your cover level usually remains the same as you get older.",
        "TPDCoverTooltipText": "You can get TPD cover as fixed (up to $5,000,000) or age-based units (up to 48). With age-based units, your cover level changes according to your age. Fixed cover means your cover level usually remains the same as you get older.",
        "IPCoverTooltipText": "For Income Protection, you will need to nominate the amount of cover that you want insured. The maximum amount of cover you can nominate is the lesser of 87% of salary and $360,000 p.a.",
        "assetRangeErrorMessage": "Please enter an amount between $1 and $5,000,000.",
        "assetTotalErrorMessage": "Total assets cannot exceed $5,000,000.",
      },
      "expenses": {
        "disabilityText": "Covers expenses such as medical equipment and modifications to your house or car in the event of disability. The NDIS may provide funding for expenses such as home and vehicle modifications for eligible people with a disability. You should consider this when estimating your insurance needs.",
        "hideDisabilityTooltip": true,
        "livingExpensesError": "Please enter an amount between $0 and $50,000.",
        "disabilityCostError": "Please enter an amount between $0 and $1,000,000.",
        "funeralExpensesError": "Please enter an amount between $0 and $50,000.",
        "livingExpensesSingleTooltipText": "Living expenses are only used for the calculation of Death cover.",
        "livingExpensesCoupleTooltipText": "As you are in a couple, please provide the expenses you are responsible for. Living expenses are only used for the calculation of Death cover.",
        "livingExpensesSingleInfoText": "As a single person you may not need to cover your living expenses.",
        "hideLivingExpenseInfoBox": false,
        "expenseRangeErrorMessage": "Please enter an amount between $1 and $50,000.",
        "expenseTotalErrorMessage": "Total expenses cannot exceed $50,000.",
        "dependantAmountRangeErrorMessage": "Please enter an amount between $1 and $50,000.",
      },
      "results": {
        "introText": "The estimates provided below depends on information provided by you and the assumptions (which may change). They don’t consider existing insurance cover you may have and are guides rather than personal advice.",
        "outroText": `
          <p>Your estimated insurance needs are affected by inflation. You can adjust the assumed rate to see how this might affect your future needs by editing <a href='#/assumptions/assumptions' tabindex='0' role='button'>assumptions</a>.</p>
          <p>When you start your insurance cost estimate on the next screen, your cover amount will be rounded up to the nearest age-based unit value.</p>
        `,
        "deathCoverSummary": "If you die, your beneficiaries can receive a lump sum to cover things like funeral expenses, living costs or debts.",
        "tpdcoverSummary": "If you become ill or injured, TPD insurance may cover rehabilitation and living costs. Along with Income Protection insurance, TPD insurance can help cover your income while you’re disabled.",
        "incomeProtectionCoverSummary": "If you can’t work due to an illness or injury, Income Protection can replace some of your income while you’re unable to work.",
        "deathCoverNotRequiredSummary": "Your assets cover the financial needs of your beneficiaries, so you may not need Death cover.",
        "tpdCoverNotRequiredSummary": "Based on your answers you may not need TPD cover. This is because the total value of your assets covers your financial needs in the event you were to become permanently disabled.",
        "incomeProtectionCoverNotRequiredSummary": "As you have changed the cover amount for Income Protection to 0% of your salary, Income Protection cover has not been included.",
      },
      "occupation": {
        "customIntroText": `Your occupation category affects your insurance fees.`,
      },
      "costs": {
        "customIntroText": `After optionally saving or printing your final estimated insurance fees, discover what the next steps for your insurance cover may involve.`,
        "memberType": "",
        "occupationClassification": "Occupation category",
        "deathCoverTitle": "Death cover amount",
        "tpdcoverTitle": "TPD cover amount",
        "incomeProtectionCoverTitle": "Income Protection cover amount (p.a)",
        "outroText": `
          <p>Insurance fees are deducted from your super account monthly. Please consider the impact insurance fees have on your overall super account balance over time. You should consider seeking advice from an authorised financial adviser before making a decision about your insurance cover.</p>
          <p>Please note, depending on the product you apply for, you may receive a 15% tax deduction for the fees, and this amount is credited back to your account, effectively reducing your fees by 15%. Insurance fees include stamp duty and administration fees to cover the cost of administering your insurance.</p>
          <p>For former Christian Super members who have special rates for Income Protection insurance, the estimated insurance fees in this calculator do not reflect your special rates.  If you make any changes to your Income Protection cover (other than Occupation Category), the special rates will no longer apply and the standard rates which are reflected in this calculator will apply.</p>
          `,
      },
      "assumptions": {
        "wageInflationError": "Please enter an amount between 0% and 10%",
        "priceInflationError": "Please enter an amount between 0% and 10%",
        "investmentReturnError": "Please enter an amount between 0% and 10%",
        "retirementAgeError": "Please enter an age between 55 and 75",
        "sgContributionError": "Please enter an amount between "+sgRate+"% and 15%",
        "ipPercentageError": "Please enter an amount between 0% and 75%",
        "tpdFutureIncomeError": "Please enter an amount between 0% and 100%",
        "ipTooltipCopy": "The amount paid to you if you’re eligible for an Income Protection benefit. The 75% default reflects the government’s proposed maximum for benefit periods beyond the first six months."
      },
      "next": {
        "rightBlock": "<p><b>Insurance calculator support</b></p><p>If you’d like help with the calculator or want to make an insurance enquiry, please get in touch.</p><a class='back-button next-page mt-4 ' href='#/cover-cost' tabindex='0' role='button'>Go back</a><a class='cta next-button mt-4 ml-2' href='https://www.australianethical.com.au/contact/' target='_blank' tabindex='0'>Contact us</a> ",
        "leftBlock": "<p>Your insurance cover estimate should give you a sense of what to expect when you apply for insurance, but final costs and coverage may vary.</p><a href='https://www.australianethical.com.au/adviser/' target='_blank'><h5>Start over</h5></a><span>To get a new estimate, you can <a class='start-over' href='#/' tabindex='0'><b>start over</b>.</a>",
      },
      "beforeWeBeginCopy": `
        <section>
          <p><strong>Purpose</strong></p>
          <p>There are many types of life insurance benefits available in the market and no product is identical to another. This calculator can estimate the amount of cover you need and the cost for:</p>
          <ul>
            <li>Death cover</li>
            <li>Total and Permanent Disablement (TPD) cover</li>
            <li>Income Protection cover.</li>
          </ul>
          <p>The estimate this calculator provides shouldn't be considered a recommendation of specific products or cover amounts because it:</p>
          <ul>
            <li>can't consider your financial circumstances</li>
            <li>doesn't include cover you may have with another provider</li>
            <li>bases results on information you enter</li>
            <li>applies a variety of assumptions to create an estimate (learn more about these in conditions and limitations).</li>
          </ul>
          <p>The Trustee doesn't intend that this calculator will influence your decision about your super or any financial product, and no such intention should be inferred. When deciding on insurance cover, always evaluate how appropriate it is for your needs.</p>
          <p>You should also consider the cost of cover over time as this may impact the amount of money you end up with in retirement. Large or multiple amounts of insurance cover may erode savings you will have available for your income when you stop working. Like most types of insurance, you have the option to change, review or cancel at any time.</p>
          <p>You shouldn't rely on the results of the calculator when making decisions about your insurance cover.</p>
          <p>We recommend you consider obtaining advice from a qualified financial adviser before making any decisions about your insurance, the need for any other types of insurance or for any replacement of insurance.</p>
          <p>Please take time to read all of the details about the calculator – how it works, the conditions and limitations.</p>
          <p><strong>How it works</strong></p>
          <p>When creating an estimate, the calculator applies factors and assumptions commonly considered in the context of life insurance.</p>
          <p>The factors you'll enter include your:</p>
          <ul>
            <li>assets</li>
            <li>liabilities</li>
            <li>income.</li>
          </ul>
          <p>The default assumptions are based on:</p>
          <ul>
            <li>government legislation</li>
            <li>regulatory guidance</li>
            <li>reputable surveys and studies.</li>
          </ul>
          <p>There are a few considerations to make in relation to the included assumptions.</p>
          <ul>
            <li>Some assumptions, such as the costs associated with living, can change unexpectedly.</li>
            <li>Some assumptions can't be changed, such as those fixed by legislation.</li>
            <li>Some assumptions you can change, like the rate of inflation you think may apply to you.</li>
            <li>Where you don't vary the assumptions, the calculator will use the default assumptions.</li>
            <li>Small changes to assumptions have the potential to significantly influence your estimate.</li>
          </ul>
          <p><strong>Conditions and limitations</strong></p>
          <p>It's important to treat the estimate provided as a guide. The calculator is limited by:</p>
          <ul>
            <li>the applied assumptions and limitations</li>
            <li>the data you enter</li>
            <li>laws and regulations relevant on the date you use the calculator</li>
            <li>the use of general insurance product features, including a maximum Income Protection estimate of $30,000 per month.</li>
          </ul>
          <p>Laws, regulations, the cost of living and your personal circumstances can change at any time. Before making any financial decisions consider your financial circumstances, needs and objectives and consider obtaining financial advice.</p>
          <p>To learn more about assumptions and limitations applied in the calculator, see the&nbsp;<a href="#/assumptions/disclaimer">disclaimer</a>.</p>
          <p><strong>General advice considerations</strong></p>
          <p>The information presented in this calculator contains general advice that has been prepared without taking account of your objectives, financial situation or needs. Before acting on the information or deciding whether to acquire or hold a product, consider its appropriateness and the relevant Product Disclosure Statement (PDS). You should consider obtaining advice from a licensed financial adviser before making a decision about your insurance needs.</p>
          <p>Neither the Trustee nor MetLife accept any liability, either direct or indirect, arising from any person relying, either wholly or partially, upon any information, provided by, resulting from, shown in, or omitted from, the calculator. In no way will the Trustee or MetLife be liable for any loss or damage caused by a user's reliance on information obtained using this calculator.</p>
        </section>
      `,
      "disclaimerCopy": `
        <section>
          <h3>About this calculator</h3>
          <p>This calculator has been designed for use by Australian Ethical Super members who are eligible to receive Death and Total & Permanent Disablement (TPD) cover, and Income Protection (IP) cover where applicable, through group insurance policies the Trustee has taken out with MetLife Insurance Limited ABN 75 004 274 882 (MetLife). It has been made available on behalf of Australian Ethical Superannuation Pty Limited ABN 43 079 259 733 (Trustee), the Trustee of Australian Ethical Retail Superannuation Fund ABN 49 633 667 743 (Fund). The calculator has been developed by Gallagher Benefit Services Pty Ltd ABN 49 611 343 803 (Gallagher), whose copyright is reserved.</p>
          <p>For former Christian Super members who have special rates for Income Protection insurance, the estimated insurance fees in this calculator do not reflect your special rates.  If you make any changes to your Income Protection cover (other than Occupation Category), the special rates will no longer apply and the standard rates which are reflected in this calculator will apply.<p>
          <p>The calculator is intended to provide an estimate of the amount of cover you may need from any IP cover (which is based on your current income level) as well as any death and TPD cover you may require in the event of your death or disability. It also provides a cost estimate.</p>
          <p>Gallagher is responsible for the calculation methodology and the outcomes produced as a result of the information you add about your circumstances. The systems and logic included in the calculator are based on existing legislation at the date of its preparation and don’t take into account any proposed legislative changes.</p>
          <p>To the extent permitted by law, neither the Trustee nor related bodies accept any liability for any omissions, errors or inaccuracies in the Insurance calculator.</p>
          <p>MetLife is the insurer and underwriter for all insurance cover provided through the Fund. As such, the insurance estimated by the calculator is provided as a guide only and doesn’t constitute a quote or guarantee that the cover will be available to you. The estimated cover may be subject to underwriting assessment and approval by the Trustee and MetLife. Premium loadings and/or policy exclusions may also apply.</p>
          <p>In using this calculator, you’ll enter certain personal and financial information. MetLife and Gallagher do not collect that information and won’t make it available to a MetLife representative that you may subsequently speak to regarding the calculator’s estimate or an application. As such, you may be required to provide the same information at a later stage, especially if you’re applying for underwritten insurance cover.</p>
          <p>This calculator and the outcomes produced in this calculator should be used as a guide only. The results should not be relied upon as a recommendation or an exact figure and do not take into account your ability to obtain the level of cover presented. Further, the results shown by the calculator are in today’s dollars. The availability of the estimated cover has not been assessed and cover may not be available to some customers depending on the eligibility criteria of an individual insurance product. Insurance needs are also different depending on individual circumstances and the type of cover you need will vary depending on your unique circumstances and requirements.</p>
          <p>The calculator is not financial advice and is not intended to be relied on for the purposes of making a decision in relation to a particular financial product. Before making any financial decisions consider your own financial circumstances, needs and objectives and consider getting professional financial advice. While the assumptions underlying this calculator are considered reasonable at the present time, these assumptions may change in the future.</p>
          <p>The amounts of insurance estimated by the calculator may not be available for purchase. The amount of insurance and its availability will depend on your medical, financial, and personal circumstances when you apply.</p>
          <p>You should contact your insurance provider directly for any eligibility, underwriting requirements, and actual costs of any insurance you apply for.</p>
          <p>You should reassess your insurance needs regularly as your circumstances may change and this could impact the amount of insurance you may require.</p>
          <p>It is important that you ensure that you have read and understood our assumptions and calculation methodology before using the calculator. The estimate provided by the calculator will depend (and may change) based on the assumptions and information provided. Gallagher in partnership with actuarial consultant Cumpston Sarjeant believe that the default assumptions on which the estimates are based are reasonable. You can edit the assumptions at any time by clicking on the Edit assumptions button at the bottom corner of any page of the calculator.</p>
          <p>This calculator is current as at 1 July 2026.</p>
          <p></p>
        </section>
      `,
      "disclaimer": {
        "trustee": "Australian Ethical Superannuation",
        "provider": "The Insurance Calculator has been made available by Australian Ethical Management Pty Ltd ABN 91 006 961 799, AFS Licence No. 235907 on behalf of Australian Ethical Limited ABN 54 006 027 121 (Trustee), the Trustee of Australian Ethical ABN 91 385 943 850 (Fund).",
        "liability": "To the extent permitted by law, neither Australian Ethical Management Pty Ltd nor Australian Ethical Limited nor related bodies accept any liability for any omissions, errors or inaccuracies in the Insurance calculator.",
      },
      "memberTypeDescriptions": {
        "intro":
        `
          <h2 tabindex="0" class="mb-3">How did you join or intend to join Australian Ethical?</h2>
          <p>The cost of your insurance cover is impacted by the way you joined Australian Ethical. It is an estimate and should be used as a guide only.</p>
        `,
        "employer": {
          "header": "Your employer created or will create an account for you",
          "description": `If your employer is a Australian Ethical partner and have created an account  on your behalf.`
        },
        "personal": {
          "header": "You previously applied through our website or will do so later",
          "description": `Anyone can apply to join Australian Ethical’s Personal Account.`
        },
        "merged": {
          "header": "Your account was  transferred from the Australian Catholic Superannuation Retirement Fund (ACSRF)",
          "description": `If your insurance cover was transferred during the merger between ACSRF and Australian Ethical and has not ceased. `,
        },
      },
      "coverCostLabels": {
        "deathCoverUnits": "Age-based Cover",
        "TPDCoverUnits": "Age-based Cover",
      }
    },
  },
  "analytics": {
    gacode: "",
    ga4code: "G-7H53KE4EB5"
  },
  api: {
    platformId: "9968378b660f4999a409bd08627eee2b"
  },
};